import { action as apiAction } from 'api/Api'
import {
  setName,
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  name: string
}

export default (payload: Payload) => async dispatch => {
  const { cardId, name } = payload

  const optimisticAction = optimisticDispatch(dispatch, setName({
    id: cardId,
    name: name.trim()
  }))

  try {
    await apiAction('RenameCard', {
      id: cardId,
      name: name.trim()
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    if (error.code !== 303) { // NoChange
      throw error
    }
  }
}
